module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-5-b71645703722f0f52fa585de4a979943.jpg";